import { Button, Grid, Modal } from '@mui/joy';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { endpoint } from '../../resource/Constant';
import { Backdrop, Box, CircularProgress, Input, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { useTechPredAuth } from './Auth/TechPredAuthProvider';
import AnimatedLoader from './AnimatedLoader';
import FinalResult from './FinalResult';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import TechStackPredictionInfo from './TechStackPredictionInfo';
import { motion, AnimatePresence } from 'framer-motion';
import './index.css';
import TechStackPredictionPopup from './TechStackPredictionPopup';

function TechPred() {
  const [input, setInput] = useState('');
  const [result, setResult] = useState();
  const [question, setQuestion] = useState();
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSteps, setShowsteps] = useState(false);
  const [removeHeading, setRemoveHeading] = useState(false);
  const { techpredlogout } = useTechPredAuth();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [showHint, setShowHint] = useState({ status: true, id: 0 });
  const placeholders = [
    'Hospital Management System...',
    'AI-powered Virtual Assistant...',
    'HR Management System for employee...',
    'Banking Project...',
    'E-commerce Platform...',
    'Educational Learning Management System (LMS)...',
    'Smart Home Automation System...',
    'Healthcare Telemedicine Platform...',
    'Logistics and Supply Chain Management...',
    'Social Media Analytics Tool...'
  ];
  const pdfref = useRef();
  const [currentText, setCurrentText] = useState('');
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const typingSpeed = 100; // Speed of typing effect
  const pauseTime = 1500; // Pause time before starting next placeholder

  useEffect(() => {
    if (charIndex < placeholders[index].length) {
      const timeout = setTimeout(() => {
        setCurrentText((prev) => prev + placeholders[index][charIndex]);
        setCharIndex((prev) => prev + 1);
      }, typingSpeed);

      return () => clearTimeout(timeout);
    } else {
      // Pause before erasing
      setTimeout(() => {
        setCharIndex(0);
        setCurrentText('');
        setIndex((prev) => (prev + 1) % placeholders.length);
      }, pauseTime);
    }
  }, [charIndex, index, placeholders]);
  const chat = () => {
    setLoading(true);
    let provideInput = '';
    selected?.forEach((i) => {
      provideInput = provideInput + question?.options[i] + ' ';
    });
    if (provideInput.length == 0 && input.length == 0) {
      return;
    }
    if (!question) {
      provideInput = input;
    }

    setSelected([]);
    setResult();
    axios
      .get(endpoint + '/api/techpred', {
        params: { message: provideInput },
        headers: { Authorization: 'Bearer ' + localStorage.getItem('techpredtoken') }
      })
      .then((res) => {
        if (res?.data?.startsWith('{"que":') || res?.data?.includes('{"que":') || res?.data?.includes('"question":')) {
          setQuestion(JSON.parse(res?.data));
          setCurrentQuestionIndex((prev) => (prev === 11 ? 1 : prev + 1));
        } else {
          setResult(JSON.parse(res?.data));
          setCurrentQuestionIndex(11);
          setQuestion();
        }
        setInput('');
        setLoading(false);
        setRemoveHeading(true);
      })
      .catch((e) => {
        toast.error(`${e?.response?.data?.detail ? e?.response?.data?.detail : 'Something went wrong'}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
        setInput('');
        if (e?.status == 401 || e?.status == 402) {
          localStorage.removeItem('techpredtoken');
          techpredlogout();
        }
      });
  };
  

  useEffect(() => {
    if (currentQuestionIndex == 1) setShowHint({ status: true, id: 1 });
  }, [currentQuestionIndex]);

  useEffect(() => {
    if (result) setShowHint({ status: true, id: 3 });
  }, [result]);

  const handleDownloadPDF = () => {
    // const element = pdfref.current;
    // html2canvas(element).then((canvas) => {
    //   const imgData = canvas.toDataURL('image/png');
    //   const pdf = new jsPDF();

    //   const imgWidth = 210; // A4 size in mm
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //   pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    //   // pdf.fillStyle = '#434343';
    //   // const pageWidth = pdf.internal.pageSize.getWidth();
    //   // const pageHeight = pdf.internal.pageSize.getHeight();
    //   // pdf.rect(0, 0, pageWidth, pageHeight);
    //   pdf.save('download.pdf');
    // });
    const element = pdfref.current;
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      const imgWidth = 210; // A4 size in mm
      const pageHeight = 297; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      while (heightLeft > 0) {
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        if (heightLeft > 0) {
          pdf.addPage();
          position = -pageHeight; // Move to the new page
        }
      }

      pdf.save('download.pdf');
    });
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      chat();
    }
  };

  return (
    <>
      <Grid container>
        {/* <Grid item sx={12} md={7}>
            <AnimatedLoader current={currentQuestionIndex} total={10} />
          </Grid> */}
        <Grid
          item
          xs={12}
          md={12}
          pt={1}
          // hidden={question?.options?.length > 0 || removeHeading}
        >
          <Typography sx={{ color: '#4f46e5', mt: 1, fontSize: '2.25rem',lineHeight:'2.5rem', fontWeight: '700' }}>Technology Stack Predictor</Typography>
          <Typography sx={{ color: 'rgb(75 85 99 / var(--tw-text-opacity, 1))', mt: 1, fontSize: '1.2rem', fontWeight: '500' }}>
            Answer Simple Questions to Get Personalized Technology Recommendations
          </Typography>
        </Grid>
        <Grid container item xs={12} sx={{ m: { sm: 5, xs: 1 }, justifyContent: 'center' }}>
          <Grid
            container
            item
            xs={12}
            md={7}
            sx={{
              p: 1,
              m: { sm: 1, xs: 0 },
              minHeight: { sm: '70vh', xs: '60vh' },
              justifyContent: 'center',
              background: '#fff',
              borderRadius: '10px'
            }}
          >
            {showHint.status && (
              <div
                style={{
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%,-50%)',
                  zIndex: '1300',
                  background: '#fff',
                  borderRadius: '10px' /* Rounded edges like real paper */,
                  boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.2)'
                }}
              >
                <TechStackPredictionPopup step={showHint.id} setShowHint={setShowHint} />
              </div>
            )}
            {showSteps && <TechStackPredictionInfo setShowsteps={setShowsteps} />}
            {!showSteps && (
              // <Grid container item xs={12} md={10} sx={{ p: { sm: 0, xs: 0 }, m: 0, justifyContent: 'center' }}>
              <AnimatedLoader current={currentQuestionIndex} total={10} />
              // </Grid>
            )}
            {question && !showSteps ? (
              <Grid container item sx={{ alignItems: 'center', justifyContent: 'center' }} xs={12} md={9}>
                <motion.div
                  key={currentQuestionIndex}
                  style={{ float: 'center' }}
                  initial={{ opacity: 0, x: -50 }} // Start from left
                  animate={{ opacity: 1, x: 0 }} // Move to original position
                  transition={{ duration: 0.5, ease: 'easeOut' }} // Smooth transition
                >
                  <Grid container item xs={12} md={12}>
                    <Typography sx={{ color: '#0A4275', mt: 1, fontSize: '1.4rem', fontWeight: '600' }}>
                      {question?.que ? question?.que : question?.question}
                    </Typography>

                    {question?.options?.map((e, index) => (
                      <Grid key={index} item m={1} mt={2}>
                        <motion.div
                          key={currentQuestionIndex}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.4, delay: index * 0.15 }} // Staggered effect for options
                        >
                          <Button
                            onClick={() => {
                              setSelected((prev) => (prev.includes(index) ? prev.filter((el) => el !== index) : [...prev, index]));
                            }}
                            sx={{
                              borderRadius: '40px',
                              color: 'white',
                              backgroundColor: selected.includes(index) ? '#154e88' : '#0b6bcb',
                              '&:hover': {
                                backgroundColor: '#154e88',
                                color: 'white'
                              },
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >
                            <Typography
                              sx={{
                                color: 'white',
                                fontSize: '1.2rem',
                                lineHeight: '1.2rem',
                                fontWeight: '400',
                                textAlign: 'center'
                              }}
                            >
                              {e}
                            </Typography>
                          </Button>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </motion.div>
              </Grid>
            ) : (
              <></>
            )}
            {result && (
              <Grid container item xs={12} md={9} py={3}>
                {/*<Grid item xs={12}>
                <h3 style={{ color: '#fff' }}>summary of the requirements based on the responses.</h3>
                {result?.summary?.map((e) => {
                  return <h4 style={{ color: '#fff' }}>{e}</h4>;
                })}
              </Grid> */}
                <FinalResult pdfref={pdfref} result={result} />
                <Button
                  onClick={handleDownloadPDF}
                  sx={{
                    //backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 70%, #006ce0 100%))',
                    backgroundColor: '#0b6bcb',
                    marginRight: '10px',
                    '&:hover': {
                      backgroundColor: '#0958a8',
                      color: 'white'
                    },
                    float: 'right',
                    color: 'white',
                    fontFamily:
                      " system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                  }}
                >
                  <h8>Download PDF</h8>
                </Button>
              </Grid>
            )}
            {!showSteps && (
              <Grid container item xs={12} md={9} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} md={9} sx={{ justifyContent: 'center', alignItems: 'center' }} justifyContent={'center'}>
                  {/* <Grid item xs={12} md={12} justifyContent={'center'} sx={{ justifyContent: 'center', background: 'black' }}> */}
                  {/* <h4 style={{ color: 'rgb(205, 20, 62)', fontSize: '40px !important', lineHeight: '40px !important' }}>Requirements</h4> */}
                  <motion.div
                    initial={{ opacity: 0, y: -50 }} // Start above with opacity 0
                    animate={{ opacity: 1, y: 0 }} // Move to normal position
                    transition={{
                      duration: 0.6, // Smooth duration
                      ease: 'easeOut' // Easing function
                    }}
                    style={{ width: '100%' }} // Ensuring it takes full width
                  >
                    <TextField
                      fullWidth
                      sx={{
                        // background: '#e3effb',
                        color: '#0A4275',
                        borderRadius: '20px',
                        '& .MuiInputBase-input': { color: '#0A4275' },
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '20px',
                          '&.Mui-focused fieldset': {
                            borderColor: '#003366',
                            borderRadius: '20px'
                          }
                        },
                        '& .MuiInputLabel-root': {
                          '&.Mui-focused': {
                            color: '#003366',
                            fontSize: '20px',
                            borderRadius: '20px'
                          }
                        }
                      }}
                      value={input}
                      id="outlined-multiline-static"
                      onKeyDown={handleKeyPress}
                      onChange={(e) => setInput(e.target.value)}
                      placeholder={currentText}
                      multiline
                      rows={4}
                      hidden={question?.options?.length > 0}
                      defaultValue=""
                    />
                  </motion.div>

                  {/* </Grid> */}
                </Grid>
              </Grid>
            )}
            {
              <Grid container item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: '5px', width: '100%' }}>
                  <Box
                    sx={{
                      width: '10px',
                      height: '10px',
                      backgroundColor: loading ? '#1976d2' : '#fff',
                      borderRadius: '50%',
                      animation: 'dot-flash 1.5s infinite ease-in-out'
                    }}
                  />
                  <Box
                    sx={{
                      width: '10px',
                      height: '10px',
                      backgroundColor: loading ? '#1976d2' : '#fff',
                      borderRadius: '50%',
                      animation: 'dot-flash 1.5s infinite ease-in-out',
                      animationDelay: '0.2s'
                    }}
                  />
                  <Box
                    sx={{
                      width: '10px',
                      height: '10px',
                      backgroundColor: loading ? '#1976d2' : '#fff',
                      borderRadius: '50%',
                      animation: 'dot-flash 1.5s infinite ease-in-out',
                      animationDelay: '0.4s'
                    }}
                  />
                </Box>
              </Grid>
            }
            <Grid item xs={12} md={9} pt={1}>
              <Button
                onClick={() => {
                  chat();
                }}
                sx={{
                  //backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 70%, #006ce0 100%))',
                  backgroundColor: '#0b6bcb',
                  marginRight: '10px',
                  '&:hover': {
                    backgroundColor: '#0958a8',
                    color: 'white'
                  },

                  fontFamily:
                    " system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}
                disabled={selected?.length == 0 && input.length == 0}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: '1.3rem',
                    lineHeight: '1.3rem',
                    fontWeight: '500',
                    textAlign: 'center'
                  }}
                >
                  Next
                </Typography>
              </Button>
            </Grid>
          </Grid>
          {currentQuestionIndex > 2 && (
            <Box
              sx={{
                height: 'fit-content',
                width: 'fit-content',
                bottom: '2%',
                right: '0%',
                position: 'fixed'
                // transform: 'translate(50%,50%)'
              }}
              item
              xs={12}
              md={12}
            >
              {/* <Button
                onClick={() => {
                  // localStorage.removeItem('techpredtoken');
                  // techpredlogout();
                }}
                sx={{
                  //backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 70%, #006ce0 100%))',
                  float: 'right',
                  backgroundColor: '#0b6bcb',
                  marginRight: '10px',
                  '&:hover': {
                    backgroundColor: '#0958a8',
                    color: 'white'
                  },
                  fontFamily:
                    " system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}
              >
                Try tech for some thing else?
              </Button> */}
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default TechPred;
